import { useEffect, useState } from 'react';
import { api, Attempt, Bank, Pack } from '../api';
import { Icon } from '../Icon';
import { ResumeBanner } from './Resume';

export function Catalogue({ onChoose, onResume }: {
  onChoose: (bank: Bank, pack: Pack) => void; onResume: (attempt: Attempt) => void;
}) {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [packs, setPacks] = useState<Pack[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([api.get<Bank[]>('/banks'), api.get<Pack[]>('/packs')])
      .then(([b, p]) => { setBanks(b); setPacks(p); })
      .catch((e) => setError(e.message));
  }, []);

  if (error) return <div className="notice notice--warn" role="alert">Could not load banks: {error}</div>;

  return (
    <>
      <h1>Choose a question bank</h1>
      <p className="muted">
        Independent practice material. Not affiliated with, endorsed by, or equivalent to any
        official examination.
      </p>

      <ResumeBanner onResume={onResume} />

      {banks.length === 0 && <p>No published banks yet.</p>}

      {banks.map((bank) => {
        const pack = packs.find((p) => p.id === bank.packId);
        return (
          <article key={bank.bankVersionId} className="card">
            <h2 className="card-title"><span className="card-badge"><Icon name="book" /></span>{bank.subject}</h2>
            <p className="muted" style={{ marginBottom: '0.75rem' }}>{bank.title}</p>
            <dl className="spec">
              <dt>Edition</dt><dd>{bank.edition}</dd>
              <dt>Owner</dt><dd>{bank.owner}</dd>
              <dt>Questions</dt><dd>{bank.itemCount}</dd>
              <dt>Published</dt><dd>{new Date(bank.publishedAt).toLocaleDateString()}</dd>
            </dl>
            <button className="btn-primary" onClick={() => pack && onChoose(bank, pack)} disabled={!pack}>
              <Icon name="sliders" />Configure a session
              <span className="visually-hidden"> for {bank.subject}</span>
            </button>
          </article>
        );
      })}
    </>
  );
}
